import { Box, Button, styled } from '@mui/material'

export const Wrapper = styled(Box)`
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.custom.gray4};
  border-radius: 2px;
`

export const Divider = styled(Box)`
  flex-shrink: 0;
  width: 1px;
  height: 16px;
  background-color: ${({ theme }) => theme.palette.custom.gray7};
`

export const ValueButton = styled(Button)`
  padding: 0;
  flex: 1;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: 100%;
`

export const MinValue = styled(ValueButton)`
  color: ${({ theme }) => theme.palette.custom.red1};
`

export const MaxValue = styled(ValueButton)`
  color: ${({ theme }) => theme.palette.custom.green1};
`
